import React from "react";
import close from "../../../../assets/img/icons/Vector copy.svg";
import CountBox from "../../../dropbox/CountBox";
import IconBox from "../../../shared/IconBox";
import mines from "../../../../assets/img/icons/Vector.svg"
import add from "../../../../assets/img/icons/add.svg"
import Button from "../../../shared/Button";
const GuestCount = ({ closeModal,count,setCount }) => {
    const increase = ()=>{
        setCount(prev=>prev+=1)
    }
    const decrease = ()=>{
        if(count > 0){
            setCount(prev=>prev-=1)

        }
    }
  return (
    <div className="ModalBackground GuestCount">
      <div className="ModalBackground--container p-[25px]">
        <div className="flex justify-between  items-center">
          <h2 className="text-[#292D32] text-[20px] font-[700]">
            تعداد مهمان ها
          </h2>
          <button onClick={closeModal}>
            <img src={close} />
          </button>
        </div>
        <hr className="my-[20px]" />
        <div className='CountBox__container flex justify-between items-center'>
            <IconBox onClick={increase} white className="CountBox__iconbox"><img width={24} src={add} /></IconBox>
            <div className="bg-[#292D32] rounded-[20px] px-[62px] py-[16px] text-[#fff] ">{count} نفر</div>
            <IconBox onClick={decrease}  white className="CountBox__iconbox"><img width={12} src={mines} /></IconBox>


        </div>
        <div className="flex gap-[12px] mt-[25px]">
            <Button varient="white" fullwidth onClick={closeModal}> حذف فیلتر</Button>
            <Button varient="primary" fullwidth>تاییدتعداد مسافرین</Button>
        </div>
      </div>
    
    </div>
  );
};

export default GuestCount;
